import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { fetchTextFile } from '../../api/resourcesApi';

const resourcesSlice = createSlice({
  name: 'resources',
  initialState: {
      textFiles: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTextFile.pending, (state) => {

      })
      .addCase(fetchTextFile.fulfilled, (state, action) => {
        const { url, content } = action.payload;
            state.textFiles[url] = {
              loading: false,
              error: null,
              content,
            };
      })
      .addCase(fetchTextFile.rejected, (state, action) => {

      });
  },
});

export default resourcesSlice.reducer;